import { onPageChange } from "./onPageChange";

type TrackingEvent = {};

export class EventBuffer {
  private buffer: TrackingEvent[] = [];
  private isSending = false;
  private lastFlush = 0;
  private flushTimeoutId: number | undefined;

  // Max waiting time before sending the batch
  private batchTimeout = 5000;

  // Max number of events to send in a batch
  private batchSize = 10;

  private apiBaseUrl: string;
  private appId: string;

  constructor(apiBaseUrl: string, appId: string) {
    this.apiBaseUrl = apiBaseUrl;
    this.appId = appId;
    onPageChange(() => this.flush());
  }

  push(event: TrackingEvent) {
    this.buffer.push(event);
    this.scheduleFlush();
  }

  async scheduleFlush() {
    const reachedSizeThreshold = this.buffer.length >= this.batchSize;
    const reachedTimeout = this.lastFlush + this.batchTimeout < Date.now();

    if (reachedSizeThreshold || reachedTimeout) {
      this.flush();
      return;
    }

    if (!this.flushTimeoutId) {
      this.flushTimeoutId = setTimeout(() => this.flush(), this.batchTimeout) as any;
    }
  }

  async flush() {
    if (this.flushTimeoutId) {
      clearTimeout(this.flushTimeoutId);
      this.flushTimeoutId = undefined;
    }

    if (this.isSending) return;
    if (this.buffer.length === 0) return;

    this.isSending = true;
    this.lastFlush = Date.now();

    const events = this.buffer.splice(0);
    this.sendBatch(events);

    this.isSending = false;
  }

  sendBatch(events: TrackingEvent[]) {
    navigator.sendBeacon(`${this.apiBaseUrl ?? ""}/widget/track`, JSON.stringify({ events, app_id: this.appId }));
  }
}
